module.exports = __webpack_public_path__ + "fa-brands-400.d034c1b2ee84dd981ef2";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-brands-400.woff
// module id = ../../../../../src/scss/webfonts/fa-brands-400.woff
// module chunks = styles